// CPC LOCAL: Popular Packages from recent on-chain Move calls (fullnode scan).

import { useState } from 'react';

import { TopPackagesTable } from '~/components/top-packages/TopPackagesTable';
import {
	FILTER_TO_API_FILTER,
	type DateFilter,
} from '~/components/top-packages/TopPackagesCard';
import { ErrorBoundary } from '~/components/error-boundary/ErrorBoundary';
import { useCpcMoveCallMetrics } from '~/hooks/useCpcMoveCallMetrics';
import { FilterList } from '~/ui/FilterList';
import { Tooltip } from '~/ui/Tooltip';
import { ReactComponent as InfoSvg } from '~/ui/icons/info_10x10.svg';

const PANEL_CLASS =
	'flex h-full flex-col rounded-xl border border-[#18233E] bg-gradient-to-b from-[#081223] to-[#0C1730] p-4 shadow-[0_0_40px_rgba(0,153,255,0.08)]';

const TOOLTIP =
	'本网络无 Indexer 聚合指标时，从近期链上交易扫描 Move 调用；并展示已配置的 DGC / CLOB / Bridge 入口函数。';

export function CpcPopularPackagesCard() {
	const [selectedFilter, setSelectedFilter] = useState<DateFilter>('3D');
	const { data, isPending } = useCpcMoveCallMetrics();
	const filteredData = data ? data[FILTER_TO_API_FILTER[selectedFilter]] : [];

	return (
		<div className={PANEL_CLASS}>
			<div className="mb-3 flex flex-wrap items-start justify-between gap-3">
				<div className="min-w-0 flex-1 pr-2">
					<div className="flex flex-wrap items-center gap-2">
						<h3 className="text-sm font-bold text-white">Popular Packages</h3>
				
					</div>
					<p className="mt-1 text-[11px] leading-relaxed text-[#848E9C]">
						近期链上 Move 调用统计（含 DGC / CLOB / Bridge 入口）
					</p>
				</div>
				<FilterList
					lessSpacing
					options={['3D', '7D', '30D']}
					value={selectedFilter}
					onChange={(val) => setSelectedFilter(val)}
				/>
			</div>

			<div className="min-h-0 flex-1 overflow-x-auto">
				<ErrorBoundary>
					<TopPackagesTable data={filteredData} isLoading={isPending} />
				</ErrorBoundary>
			</div>
		</div>
	);
}
